import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Space } from 'antd';
import styled from 'styled-components';
import { checkPersonalPhoneNumber } from '../../util/utils';

const StyledDiv = styled.div``;

interface UploadBiddersModalProps {
  visible: boolean;
  onFinish: (tempBidders: any[]) => void;
  onCancel: () => void;
}

function UploadBiddersModal({
  visible,
  onFinish,
  onCancel,
}: UploadBiddersModalProps) {
  const [form] = Form.useForm();

  return (
    <StyledDiv>
      <Modal
        visible={visible}
        title="업체 업로드"
        okText="확인"
        cancelText="취소"
        width={900}
        closable
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((formData) => {
              form.resetFields();
              onFinish(formData.tempBidders);
            })
            .catch((info) => {
              console.log('Validate Failed:', info);
            });
        }}
      >
        <Form name="dynamic_form_nest_item" form={form} autoComplete="off">
          <Form.List name="tempBidders">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space
                    key={key}
                    style={{
                      display: 'flex',
                      marginBottom: 8,
                    }}
                    align="baseline"
                  >
                    <Form.Item
                      {...restField}
                      name={[name, 'enterpriseName']}
                      rules={[
                        {
                          required: true,
                          message: '회사명을 입력하세요.',
                        },
                      ]}
                    >
                      <Input placeholder="회사명" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'userName']}
                      rules={[
                        {
                          required: true,
                          message: '담당자명을 입력하세요.',
                        },
                      ]}
                    >
                      <Input placeholder="담당자명" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'personalPhone']}
                      rules={[
                        {
                          required: true,
                          message: '휴대전화번호를 입력하세요.',
                        },
                        {
                          validator: (_, value) =>
                            checkPersonalPhoneNumber(value),
                          message: '휴대전화번호가 올바르지 않습니다.',
                        },
                      ]}
                    >
                      <Input placeholder="휴대전화번호" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'email']}
                      rules={[
                        {
                          required: true,
                          message: '이메일을 입력하세요.',
                        },
                        {
                          type: 'email',
                          message: '이메일 입력이 잘못 되었습니다.',
                        },
                      ]}
                    >
                      <Input placeholder="이메일" />
                    </Form.Item>
                    <MinusCircleOutlined
                      onClick={() => remove(name)}
                      rev={undefined}
                    />
                  </Space>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined rev={undefined} />}
                  >
                    추가
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    </StyledDiv>
  );
}

export default UploadBiddersModal;
